// removed by extract-text-webpack-plugin
module.exports = {"info-box":"dh-dh-plastic-counter-info-box","info-box__inner":"dh-dh-plastic-counter-info-box__inner","info-box__paragraph":"dh-dh-plastic-counter-info-box__paragraph","info-box__paragraph--darker":"dh-dh-plastic-counter-info-box__paragraph--darker","info-box__link-button":"dh-dh-plastic-counter-info-box__link-button","info-box__big-text":"dh-dh-plastic-counter-info-box__big-text","app--small":"dh-dh-plastic-counter-app--small","info-box__text-line":"dh-dh-plastic-counter-info-box__text-line"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/InfoBox.css
// module id = 24
// module chunks = 0